module.exports = __webpack_public_path__ + "static/media/ic_orders.bf70c7c3.svg";